module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Dedication"
    }
  }, [_c('p', {
    staticClass: "front-title"
  }, [_c('i', [_vm._v("To Dagfinn Kjeholt and Peter Taylor")])]), _vm._v(" "), _c('p', {
    staticClass: "front-para"
  }, [_vm._v("Maritime power is the means whereby we control the sea for our own purposes … but it is safe to say that no factor is more influential than the quality and training of the men who handle and fight the instruments.")]), _vm._v(" "), _c('p', {
    staticClass: "front-right"
  }, [_vm._v("Steven Roskill"), _c('br'), _c('i', [_vm._v("The Navy at War 1939–1945")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13a0f472","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/02_Dedication.vue
// module id = 57
// module chunks = 0